import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref } from 'vue'
import TooltipStandard from '@/design-system/atoms/TooltipStandard.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContainerLogo',
  props: {
  hoverText: { type: String, default: '' },
  logoSrc: { type: String, default: '' }
},
  setup(__props) {

const props = __props
const logoHovered = ref<boolean>(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "logo",
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (logoHovered.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (logoHovered.value = false))
  }, [
    _createElementVNode("img", {
      class: "logo-image",
      alt: "logo",
      src: props.logoSrc
    }, null, 8, _hoisted_1),
    (__props.hoverText.length && logoHovered.value)
      ? (_openBlock(), _createBlock(TooltipStandard, {
          key: 0,
          arrowPosition: "top-left",
          text: __props.hoverText,
          positionAbsoulute: true
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})